var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetCapit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 66.9674L65.2601 180H0V66.9674Z",
    fill: "#FFC933"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-14.1704 -2.68076L15.319 -10.3403L38.0401 9.30727e-05L141.959 180H65.4011L-0.000196874 66.7181L-14.1704 -2.68076Z",
    fill: "#CC50A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.16 0L180 110.773L196.851 176.17L168.511 184.979L142.029 180L38.2979 0H116.16Z",
    fill: "#47C873"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.918 0L180 24.391V110.773L116.044 0H165.918Z",
    fill: "#FB5638"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180 24.391L165.918 0H180V24.391Z",
    fill: "#FB5638"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M149.997 113.357H29.9985V132.423H149.997V113.357Z",
    fill: "#999999"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.997 132.423H29.9985V137.424H149.997V132.423Z",
    fill: "#383B3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9999 47.5817C73.0525 35.5731 52.35 28.5159 29.9985 28.5159V113.357C35.9883 113.357 41.8617 113.868 47.5732 114.844C63.1748 117.502 77.5926 123.633 89.9958 132.423C102.399 123.633 116.817 117.502 132.418 114.844C138.134 113.872 144.003 113.357 149.993 113.357V28.5159C127.641 28.5159 106.939 35.5731 89.9916 47.5817H89.9999Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.999 90.0084C104.999 98.2911 98.2824 105.008 89.9998 105.008C81.7172 105.008 75.0005 98.2911 75.0005 90.0084H104.999Z",
    fill: "#383B3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0025 72.6789C73.0025 76.8202 69.6462 80.1806 65.5008 80.1806C61.3553 80.1806 57.999 76.8243 57.999 72.6789C57.999 68.5334 61.3553 65.1771 65.5008 65.1771C69.6462 65.1771 73.0025 68.5334 73.0025 72.6789Z",
    fill: "#383B3F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.997 72.6789C121.997 76.8202 118.636 80.1806 114.495 80.1806C110.354 80.1806 106.993 76.8243 106.993 72.6789C106.993 68.5334 110.349 65.1771 114.495 65.1771C118.64 65.1771 121.997 68.5334 121.997 72.6789Z",
    fill: "#383B3F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9978 132.423C99.9978 137.947 95.52 142.425 89.9996 142.425C84.4792 142.425 80.0015 137.947 80.0015 132.423H100.002H99.9978Z",
    fill: "#383B3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetCapit);
export default __webpack_public_path__ + "static/media/getCapit.4ed4cb1a93d8924665c7518669a0edb5.svg";
export { ForwardRef as ReactComponent };